module.exports = __webpack_public_path__ + "static/img/weather58.355d8255.png";